import './Separator.scss'

const Separator = ({ message, type }) => <div className={`separator ${type}`}>{message}</div>

export default Separator
